export default __webpack_public_path__ + "static/media/fr6.59168a73.jpg";